import { render, staticRenderFns } from "./page-language.vue?vue&type=template&id=88a9e852&scoped=true"
import script from "./page-language.vue?vue&type=script&lang=ts"
export * from "./page-language.vue?vue&type=script&lang=ts"
import style0 from "./page-language.vue?vue&type=style&index=0&id=88a9e852&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a9e852",
  null
  
)

export default component.exports